import { c as _c } from "react/compiler-runtime";
import { Link03Icon } from '@systemeio/icons';
import { AffiliateCopyField } from 'modules/affiliate/components/affiliate-card';
import { getUrlPathPrefix } from 'shared/components/form-url-path-input';
import useUser from 'shared/hooks/use-user';
import { getPublicPath } from 'shared/utils/locale/get-locale-for-link';
interface AffiliatePromotionLinkProps {
  affiliateId?: string;
}
const AffiliateDashboardPromotionLink = t0 => {
  const $ = _c(6);
  const {
    affiliateId
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] !== affiliateId || $[1] !== user?.dashboardLocale) {
    t1 = affiliateId ? `${getUrlPathPrefix(process.env.NEXT_PUBLIC_SIO_HOST_SCHEME, process.env.NEXT_PUBLIC_SIO_HOST_NAME)}${getPublicPath(user?.dashboardLocale).slice(1)}?sa=${affiliateId}` : undefined;
    $[0] = affiliateId;
    $[1] = user?.dashboardLocale;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const url = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Link03Icon className="text-icon-primary size-4 shrink-0" aria-hidden="true" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== url) {
    t3 = <AffiliateCopyField variant="primary" icon={t2} value={url} />;
    $[4] = url;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export default AffiliateDashboardPromotionLink;